export enum AuthMutationTypes {
  SET_USER = "SET_USER",
  SET_PARTNER = "SET_PARTNER",
  SET_COMPANY = "SET_COMPANY",
  SET_SITE = "SET_SITE",
  SET_GROUP = "SET_GROUP",
  SET_AGMS_SITE = "SET_AGMS_SITE",
  SET_AGMS_GROUP = "SET_AGMS_GROUP",
  SET_AGMS_TEMPLATE = "SET_AGMS_TEMPLATE",
}
